export {}

const observerSettings = {
  threshold: 0,
}

const callback = (entries: IntersectionObserverEntry[]) => {
  entries.forEach((entry) => {
    entry.target.classList.toggle("--view-hidden", !entry.isIntersecting)
  })
}

const observer = new IntersectionObserver(callback, observerSettings)

const groups = document.querySelectorAll(".g-testimonials.--infinite")
groups.forEach((group) => {
  observer.observe(group)

  const inner = group.querySelector(".g-testimonials__inner")
  const items = group.querySelectorAll(".i-testimonial")

  if (!inner) return

  items.forEach((item) => {
    const duplicatedItem = item.cloneNode(true) as HTMLElement

    duplicatedItem.setAttribute("aria-hidden", "true")

    inner.appendChild(duplicatedItem)
  })
})
